import styled from "styled-components";

export const StyledSlider = styled.div`
	width: calc(100% + (50vw - 472px));

	@media screen and (min-width: 1200px) {
		width: calc(100% + (50vw - 562px));
	}

	@media screen and (min-width: 1366px) {
		width: ${(props) => (props.decisionBody ? "calc(100% + (50vw - 620px))" : "calc(100% + (50vw - 620px))")};
	}

	@media screen and (min-width: 1920px) {
		width: ${(props) => (props.decisionBody ? "calc(100% + (50vw - 889px))" : "calc(100% + (50vw - 895px))")};
	}

	.swiper-slide {
		max-width: min-content;
		padding-right: 2rem;
	}
`;
